import { Pipe, PipeTransform } from '@angular/core';
import { ModalWindowComponent } from './modal-window.component';

@Pipe({ name: 'modelWindowToolbarAction' })
export class ModelWindowToolbarActionPipe implements PipeTransform {
  constructor() {}

  transform(callback: Function, modalWindow: ModalWindowComponent): boolean {
    return callback.bind(null, { modalWindow, component: modalWindow?.popupComponent, modalId: modalWindow?.modalId });
  }
}
